import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/anim";
import { legalContent } from "@/i18n/legal";

export default function LegalPage({ doc }) {
  const { lang } = useLang();
  const c = legalContent[lang][doc];

  return (
    <div className="pb-24 pt-36 sm:pt-44" data-testid="legal-page">
      <div className="mx-auto max-w-3xl px-5 sm:px-10">
        <Reveal>
          <p className="eyebrow">{c.eyebrow}</p>
        </Reveal>
        <h1 className="mt-6 font-display text-4xl italic leading-[1.02] text-white sm:text-6xl">
          {c.title}
        </h1>
        <Reveal delay={0.1}>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
            {c.updated}
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-sm leading-relaxed text-neutral-300 sm:text-base">
            {c.intro}
          </p>
        </Reveal>

        <div className="mt-12 space-y-10">
          {c.sections.map((section, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <section data-testid={`legal-section-${i}`}>
                <h2 className="font-display text-xl text-white sm:text-2xl">
                  {section.h}
                </h2>
                {section.p.map((para, j) => (
                  <p key={j} className="mt-3 text-sm leading-relaxed text-neutral-400">
                    {para}
                  </p>
                ))}
              </section>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="mt-16 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-400 transition-colors duration-300 hover:text-gold"
          >
            <ArrowLeft size={14} />
            {c.back}
          </Link>
        </Reveal>
      </div>
    </div>
  );
}
